export default __webpack_public_path__ + "static/media/32.731a31ee.png";